import { createApi } from '@reduxjs/toolkit/query/react';
import  axiosInstance  from '../axiosinterceptor';
import { base_URL } from '../utils/api';

const axiosBaseQuery =
  ({ baseUrl } = { baseUrl: '' }) =>
  async ({ url, method, data, params }) => {
    try {
      const result = await axiosInstance({
        url: url,
        method,
        data,
        params,
      });
      return { data: result.data };
    } catch (axiosError) {
      const err = axiosError;
      return {
        error: {
          status: err.response?.status,
          data: err.response?.data || err.message,
        },
      };
    }
  };

export const apiSlice = createApi({
  reducerPath: 'api',
  baseQuery: axiosBaseQuery({ baseUrl: base_URL }),
  endpoints: (builder) => ({
    getData2: builder.query({
      query: () => {
        const hcp_line_id = localStorage.getItem('last_hcp_line_id');
        return {
          url: `/getEpisodeDataAcs`,
          method: 'GET',
          params: { hcp_line_id },
        };
      },
    }),
  }),
});

export const {
  useLazyGetData2Query,
  useGetData2Query,
} = apiSlice;